const { fetchJsonApi, fetchAuthorizedJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

/**
 * @return Promise that returns all available tutorials.
 */

function fetchTutorials(apiUrl, { platform, version = 1 } = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/tutorials',
    query: { lang: getApiLanguage(), platform, version },
    expectedStatus: 200,
    description: 'Fetching tutorials',
  });
}

function markTutorialAsSeen(apiUrl, token, tutorialId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/tutorials/read/${tutorialId}`,
    expectedStatus: 204,
    description: 'Marking tutorial as seen',
  });
}

module.exports = {
  fetchTutorials,
  markTutorialAsSeen,
};
